<div
    class="modal-header"
    data-testid="t-customerratings-div-1752672977568-1"
>
    <button
        type="button"
        [attr.aria-label]="'button.discard' | i18n"
        class="btn btn-close"
        (click)="d()('Close click')"
        data-testid="t-customerratings-button-1752672977568-1"
    >
        <i
            class="oc-general-cancel"
            data-testid="t-customerratings-i-1752672977568-1"
        ></i>
    </button>
    <span
        class="h5 modal-title"
        data-testid="t-customerratings-span-1752672977568-1"
        >{{ modalMessageTitle() }}</span
    >
</div>

<div
    class="modal-body"
    data-testid="t-customerratings-div-1752672977568-17"
>
    <div
        class="table-responsive"
        data-testid="t-customerratings-div-1752672977568-16"
    >
        <table
            class="table"
            data-testid="t-customerratings-table-1752672977568-1"
        >
            <thead data-testid="t-customerratings-thead-1752672977568-1">
                <tr data-testid="t-customerratings-tr-1752672977568-1">
                    <th
                        class="text-nowrap cursor-pointer"
                        data-testid="t-customerratings-th-1752672977568-1"
                    >
                        {{ 'prompt.user' | i18n }}
                    </th>
                    <th
                        class="text-nowrap cursor-pointer"
                        data-testid="t-customerratings-th-1752672977568-2"
                    >
                        {{ 'mws.rating' | i18n }}
                    </th>
                    <th
                        class="text-nowrap cursor-pointer"
                        data-testid="t-customerratings-th-1752672977568-3"
                    >
                        {{ 'mws.date' | i18n }}
                    </th>
                </tr>
            </thead>
            <tbody data-testid="t-customerratings-tbody-1752672977568-1">
                <tr
                    class="ng-star-inserted"
                    data-testid="t-customerratings-tr-1752672977568-2"
                >
                    <td
                        class="align-middle"
                        data-testid="t-customerratings-td-1752672977568-1"
                    >
                        <span
                            href="javascript:void(0)"
                            data-testid="t-customerratings-span-1752672977568-2"
                            >f.blume</span
                        >
                    </td>
                    <td
                        class="align-middle"
                        data-testid="t-customerratings-td-1752672977568-2"
                    >
                        <div
                            class="message-date text-muted"
                            data-testid="t-customerratings-div-1752672977568-8"
                        >
                            <div
                                class="ui-stars text-large text-nowrap"
                                data-testid="t-customerratings-div-1752672977568-7"
                            >
                                <!---->
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-2"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-2"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-3"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-3"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-4"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-5"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-4"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-6"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-7"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-5"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-8"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-9"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star half-filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-6"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-10"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-11"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td data-testid="t-customerratings-td-1752672977568-3"><span data-testid="t-customerratings-span-1752672977568-3">1.1.2020</span></td>
                </tr>
                <tr
                    class="ng-star-inserted"
                    data-testid="t-customerratings-tr-1752672977568-3"
                >
                    <td
                        class="align-middle"
                        data-testid="t-customerratings-td-1752672977568-4"
                    >
                        <span
                            href="javascript:void(0)"
                            data-testid="t-customerratings-span-1752672977568-4"
                            >f.blume</span
                        >
                    </td>
                    <td
                        class="align-middle"
                        data-testid="t-customerratings-td-1752672977568-5"
                    >
                        <div
                            class="message-date text-muted"
                            data-testid="t-customerratings-div-1752672977568-15"
                        >
                            <div
                                class="ui-stars text-large text-nowrap"
                                data-testid="t-customerratings-div-1752672977568-14"
                            >
                                <!---->
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-9"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-12"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-13"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-10"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-14"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-15"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-11"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-16"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-17"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-12"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-18"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-19"
                                    ></i>
                                </div>
                                <div
                                    class="ui-star half-filled ng-star-inserted"
                                    data-testid="t-customerratings-div-1752672977568-13"
                                >
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-20"
                                    ></i>
                                    <i
                                        class="oc-star-filled"
                                        data-testid="t-customerratings-i-1752672977568-21"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td data-testid="t-customerratings-td-1752672977568-6"><span data-testid="t-customerratings-span-1752672977568-5">1.1.2020</span></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
